import React from "react";
import {useNavigate} from "react-router-dom";

const BugReport = () => {
    const navigate = useNavigate()
    return (
        <div className="container">
            <button className={'back-button'} onClick={() => navigate(`/`)}>
                <i className={'fi fi-rr-angle-left'}></i>
                <p className={'back-button-contents'}>Home</p>
            </button>
            <div className="dashboard">
                <iframe
                    src="https://airtable.com/embed/appeAZifmvRXJPrNv/pagyrtzIZfU8wLNLF/form"
                    width="100%"
                    height="750"
                    style={{background: "transparent", border: "0px solid #ccc"}}
                    title="Bug Report Form"
                ></iframe>
            </div>
        </div>
    );
}

export default BugReport;